export const AIRLINE_END_USER = "airline_end_user";
export const ASA_APPROVED = "asa_approved";
export const BILLING_ADDRESS = "billing_address";
export const CAAC_APPROVED = "caac_approved";
export const COMPANY_TYPE = "company_type";
export const CUSTOMER_CREDIT_TERMS = "customer_credit_terms";
export const DER = "der";
export const DO_NOT_EXCHANGE = "do_not_exchange";
export const EASA_APPROVED = "easa_approved";
export const END_USER_AGREEMENT_REQUESTED = "end_user_agreement_requested";
export const EXPORT_APPROVAL_REQUIRED = "export_approval_required";
export const EXPORT_COMPLIANT = "export_compliant";
export const FAA_APPROVED = "faa_approved";
export const FAX = "fax";
export const FREIGHT_FORWARDER = "freight_forwarder";
export const IMPERFECT_TRACE = "imperfect_trace";
export const IMPERFECT_TRACE_REASON = "imperfect_trace_reason";
export const INTERNAL_NOTE = "internal_note";
export const LEASING_COMPANY = "leasing_company";
export const OEM = "oem";
export const RELATED_COMPANY_ID = "related_company_id";
export const REPAIR_STATION = "repair_station";
export const REPAIR_STATUS = "repair_status";
export const STATUS = "status";
export const WEBSITE = "website";
export const MRO = "mro";
export const SECOND_QC_EXPORT_COMPLIANCE_REMINDER_SENT =
  "second_qc_export_compliance_reminder_sent";
export const THIRD_QC_EXPORT_COMPLIANCE_REMINDER_SENT =
  "third_qc_export_compliance_reminder_sent";
export const TCCA_APPROVED = "tcca_approved";
export const UK_CAA_APPROVED = "uk_caa_approved";
export const AFTER_MARKET = "after_market";
export const DISTRIBUTION = "distribution";
export const GOVT_MILITARY = "govt_military";
export const OTHER_NA = "other";
export const OTHER_APPROVED = "other_approved";
export const PMA = "pma";
export const PHYSICAL_ADDRESS = "physical_address";
export const ULTIMATE_CONSIGNEE_CCS = "ultimate_consignee_ccs";
export const ULTIMATE_CONSIGNEE_FORM_BODY = "ultimate_consignee_form_body";
export const ULTIMATE_CONSIGNEE_FORM_SUBJECT =
  "ultimate_consignee_form_subject";
export const ULTIMATE_CONSIGNEE_FORM_URL = "ultimate_consignee_form_url";
export const VENDOR_CREDIT_TERMS = "vendor_credit_terms";
export const VENDOR_TRACE_PREAPPROVAL_REQUIRED =
  "vendor_trace_preapproval_required";

export const STRICT_TYPES = {
  [IMPERFECT_TRACE]: {
    label: "Imperfect Trace"
  }
};

export const APPROVAL_TYPES = {
  [DER]: {
    label: "DER"
  },
  [PMA]: {
    label: "PMA"
  }
};

export const COMPANY_TYPES = {
  [AFTER_MARKET]: {
    label: "After Market"
  },
  [AIRLINE_END_USER]: {
    label: "Airline/End-User"
  },
  [DISTRIBUTION]: {
    label: "Distribution"
  },
  [FREIGHT_FORWARDER]: {
    label: "Freight Forwarder"
  },
  [GOVT_MILITARY]: {
    label: "Government/Military"
  },
  [LEASING_COMPANY]: {
    label: "Leasing Company"
  },
  [MRO]: {
    label: "MRO"
  },
  [OEM]: {
    label: "OEM"
  },
  [PMA]: {
    label: "PMA"
  },
  [REPAIR_STATION]: {
    label: "Repair Station"
  },
  [OTHER_NA]: {
    label: "Other"
  }
};

export const COMPANY = "company";
export const CONTACT = "contact";
export const NO_BIZ = "do_not_do_business";
export const OUT_OF_BIZ = "out_of_business";
export const ACTIVE = "active";
export const OBSOLETE = "obsolete";
export const CREDIT_HOLD = "credit_hold";
export const LIABILITIES_OWED = "liabilities_owed";
export const PURCHASES_OWED = "purchases_owed";
export const LIABILITIES_TO_BE_OWED = "liabilities_to_be_owed";
export const MANAGER_CONSENT_NEEDED = "manager_consent_needed";
export const MANDATORY_ADDITIONAL_VERBIAGE = "mandatory_additional_verbiage";
export const REPAIR_LIABILITIES_OWED = "repair_liabilities_owed";
export const REPAIR_STATION_STATUS = "repair_station_status";
export const VENDOR_STATUS = "vendor_status";

export const COMPANY_STATUSES = {
  [NO_BIZ]: {
    label: "Do Not Do Business"
  },
  [OUT_OF_BIZ]: {
    label: "Out of Business"
  },
  [ACTIVE]: {
    label: "Active"
  },
  [OBSOLETE]: {
    label: "Obsolete"
  },
  [CREDIT_HOLD]: {
    label: "Credit Hold"
  }
};

export const PASS = "true";
export const FAIL = "false";

export const PASS_FAIL = {
  [PASS]: {
    label: "PASS"
  },
  [FAIL]: {
    label: "FAIL"
  }
};

export const SALUTATIONS = [
  { text: "Mr.", value: "Mr." },
  { text: "Mrs.", value: "Mrs." },
  { text: "Ms.", value: "Ms." }
];

export const NOT_APPROVED = "not_approved";
export const APPROVAL_REQUESTED = "approval_requested";
export const PENDING = "pending";
export const APPROVED = "approved";
export const CAN_APPROVE = "can_approve";
export const DENIED = "denied";

export const APPROVAL_STATUSES = {
  [NOT_APPROVED]: {
    label: "Not Approved",
    selectableStatuses: []
  },
  [APPROVAL_REQUESTED]: {
    label: "Approval Requested",
    selectableStatuses: [APPROVAL_REQUESTED, PENDING, APPROVED, DENIED],
    selectableRepairStatus: [MANAGER_CONSENT_NEEDED]
  },
  [PENDING]: {
    label: "Pending",
    selectableStatuses: [PENDING, APPROVED, DENIED],
    selectableRepairStatus: [MANAGER_CONSENT_NEEDED]
  },
  [APPROVED]: {
    label: "Approved",
    selectableStatuses: [APPROVED, DENIED],
    selectableRepairStatus: [MANAGER_CONSENT_NEEDED]
  },
  [DENIED]: {
    label: "Denied",
    selectableStatuses: [APPROVED, DENIED],
    selectableRepairStatus: [MANAGER_CONSENT_NEEDED]
  }
};

export const REPAIR_STATION_APPROVAL_STATUSES = Object.assign(
  APPROVAL_STATUSES,
  {
    [MANAGER_CONSENT_NEEDED]: {
      label: "Mgmt. Consent Needed",
      selectableStatuses: [APPROVED, DENIED, MANAGER_CONSENT_NEEDED],
      selectableRepairStatus: []
    }
  }
);

export const NET_30 = "net_30";
export const NET_60 = "net_60";
export const NET_45 = "net_45";
export const NET_15 = "net_15";
export const NET_10 = "net_10";
export const NET_5 = "net_5";
export const DUE_UPON_RECEIPT = "due_upon_receipt";
export const CREDIT_CARD = "credit_card";
export const WIRE_IN_ADVANCE = "wire_in_advance";
export const CHECK_IN_ADVANCE = "check_in_advance";

export const VENDOR_TERMS = {
  [NET_60]: {
    label: "Net-60"
  },
  [NET_45]: {
    label: "Net-45"
  },
  [NET_30]: {
    label: "Net-30"
  },
  [NET_15]: {
    label: "Net-15"
  },
  [NET_10]: {
    label: "Net-10"
  },
  [NET_5]: {
    label: "Net-5"
  },
  [DUE_UPON_RECEIPT]: {
    label: "Due upon receipt"
  },
  [CREDIT_CARD]: {
    label: "Credit card"
  },
  [WIRE_IN_ADVANCE]: {
    label: "Wire in advance"
  },
  [CHECK_IN_ADVANCE]: {
    label: "Check in advance"
  }
};

export const PO_VENDOR_TERMS = {
  [NET_30]: {
    label: "Net-30"
  },
  [NET_60]: {
    label: "Net-60"
  },
  [NET_45]: {
    label: "Net-45"
  },
  [NET_15]: {
    label: "Net-15"
  },
  [NET_10]: {
    label: "Net-10"
  },
  [NET_5]: {
    label: "Net-5"
  },
  [DUE_UPON_RECEIPT]: {
    label: "Due upon receipt"
  },
  [CREDIT_CARD]: {
    label: "Credit card"
  },
  [WIRE_IN_ADVANCE]: {
    label: "Wire in advance"
  },
  [CHECK_IN_ADVANCE]: {
    label: "Check in advance"
  }
};
export const CREDIT_REFERENCES = "credit_references";

export const ATTACHMENT_TYPES = {
  approved_vendors_list: {
    label: "Approved Vendors List"
  },
  blanket_exchange_agreement: {
    label: "Blanket Exchange Agreement"
  },
  business_license: {
    label: "Business License"
  },
  capabilities_list: {
    label: "Capabilities List"
  },
  certificate_of_status_form: {
    label: "Certificate of Status Form (W-8/BEN)"
  },
  certifications: {
    label: "Certifications"
  },
  consolidated_list_view_verification: {
    label: "Consolidated List View Verification"
  },
  signed_consignment_agreement: {
    label: "Consignment Agreement"
  },
  signed_credit_application: {
    label: "Credit Application"
  },
  credit_references: {
    label: "Credit References"
  },
  signed_customer_service_agreement: {
    label: "Customer Service Agreement"
  },
  dispute_correspondences: {
    label: "Dispute Correspondences"
  },
  signed_end_user_agreement: {
    label: "End-User Agreement"
  },
  external_link: {
    label: "External Link"
  },
  financials: {
    label: "Financials"
  },
  identification: {
    label: "Identification (current, gov't issued)"
  },
  kyc_form: {
    label: "Know Your Customer Form"
  },
  resale_certificate: {
    label: "Resale Certificate"
  },
  supplier_evaluation: {
    label: "Supplier Evaluation"
  },
  tax_excemption_certificate: {
    label: "Tax Excemption Certificate"
  },
  tax_identification_form: {
    label: "Tax Identification Form (W-9)"
  },
  trade_partners_shipment_records_search: {
    label: "Trade Partners Shipment Records Search"
  },
  website_address: {
    label: "Website Address"
  },
  wire_detail_information: {
    label: "Wire Detail Information"
  }
};

export const BLANKET_EXCHANGE_AGREEMENT = "blanket_exchange_agreement";



// WEBPACK FOOTER //
// ./app/modules/companies/constants.js